import React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { ListGroup } from "react-bootstrap";

interface Props {
  Title: string;
  Params?: any;
}

const ThankYou = (props: Props): any => {
  const location = useLocation();
  const [orderId, setOrderId] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (location.state) {
      let boughtItems: any = [];
      location.state.order.purchase_units?.forEach((item: any) => {
        if (item.payments.captures) {
          let id: string = item.payments.captures[0].id;
          setOrderId(id);
        }
        if (item.items) {
          boughtItems.push(item.items);
        }
      });
      setItems(boughtItems);
    }
  }, [location]);

  const getItems = (): any => {
    let itemList: any = [];
    if (items && items.length > 0 && orderId != "") {
      items.forEach((itemGroup: any) => {
        if (itemGroup.length > 0) {
          itemGroup.forEach((item: any, index: number) => {
            itemList.push(
              <li key={index} className="list-group-item">
                <strong>Item:</strong> {item.name} <strong>Quantity:</strong>{" "}
                {item.quantity}
              </li>
            );
          });
        }
      });
    }
    return itemList;
  };

  return (
    <>
      <div className="wrapper">
        <div className="section">
          <div className="container">
            <div className="row">
              <div className="col-md-6 ml-auto mr-auto text-center">
                <h2 className="title text-center">{props.Title}</h2>
                <p>
                  <FontAwesomeIcon
                    className="center"
                    icon={faCircleCheck}
                    size="3x"
                  />
                </p>
                <hr />
                <p>
                  Thank you for purchasing from me. Your order details are below
                </p>
                <p>
                  <strong>Order Id: {orderId}</strong>
                </p>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 ml-auto mr-auto">
                <ul className="ListGroup">{getItems()}</ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThankYou;
